<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item label="奖品名称" prop="prizeName">
                <a-input v-model="queryParam.prizeName" placeholder="请输入奖品名称" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="奖品图片" prop="prizeCover">-->
<!--                <a-input v-model="queryParam.prizeCover" placeholder="请输入奖品图片" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item label="奖品概率" prop="probability">
                  <a-input v-model="queryParam.probability" placeholder="请输入奖品概率" allow-clear/>
                </a-form-item>
              </a-col>
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="是否禁用" prop="isBan">-->
<!--                  <a-input v-model="queryParam.isBan" placeholder="请输入是否禁用" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
              <a-col :md="5" :sm="24">
                <a-form-item label="地址" prop="address">
                  <a-input v-model="queryParam.address" placeholder="请输入地址" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['prize:prize:add']">
          <a-icon type="plus" />新增
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['prize:prize:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['prize:prize:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-butt/>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <span slot="isBan" slot-scope="text, record">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="record.isBan == 1" @change="changeIsOpen($event,record)"/>
        </span>
        <img slot="prizeCover" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.prizeCover" v-image-preview :src="record.prizeCover">

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['prize:prize:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['prize:prize:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['prize:prize:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['prize:prize:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePrize,changeIsOpen, delPrize } from '@/api/prize/prize'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Prize',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        prizeName: null,
        prizeCover: null,
        probability: null,
        isBan: null,
        address: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '奖品名称',
          dataIndex: 'prizeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '奖品图片',
          dataIndex: 'prizeCover',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'prizeCover' },
        },
        {
          title: '奖品概率',
          dataIndex: 'probability',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否禁用',
          dataIndex: 'isBan',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isBan'},
        },
        {
          title: '奖品类型',
          dataIndex: 'isOffline',
          ellipsis: true,
          align: 'center',
          customRender: function (t, r, index) {
            if(t == 0) {
              return '会员'
            }else if(t == 1) {
              return '实体奖品'
            }
          }
        },
        {
          title: '会员天数',
          dataIndex: 'vipDays',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '地址',
        //   dataIndex: 'address',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '插入时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询抽奖奖品列表 */
    getList () {
      this.loading = true
     pagePrize(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },



    changeIsOpen (e,record) {
      record.isBan = e ? true : false
      changeIsOpen({id:record.id,isBan:record.isBan}).then(response => {
        this.$message.success(
          '操作成功'
        )
        return  record.isBan = e ? 1 : 0
      })
    },



    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        prizeName: undefined,
        prizeCover: undefined,
        probability: undefined,
        isBan: undefined,
        address: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delPrize(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('prize/prize/export', {
            ...that.queryParam
          }, `抽奖奖品_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
